import React, { useEffect, useState } from 'react';
import EndUserTaskFiltersView from '../view/EndUserTaskFiltersView';
import styled from 'styled-components/macro';

const statusOptions = [
  {
    value: 'assigned',
    'data-testid': `task-status-assigned`,
    text: 'Assigned'
  },
  {
    value: 'inProgress',
    'data-testid': `task-status-inProgress`,
    text: 'In progress'
  },
  {
    value: 'complete',
    'data-testid': `task-status-complete`,
    text: 'Complete'
  }
];

const priorityOptions = [
  {
    value: 'high',
    'data-testid': `task-priority-high`,
    text: 'High'
  },
  {
    value: 'medium',
    'data-testid': `task-priority-medium`,
    text: 'Medium'
  },
  {
    value: 'low',
    'data-testid': `task-priority-low`,
    text: 'Low'
  }
];

const CountSpan = styled.span`
  && {
    color: #52535b;
    font-weight: 300;
  }
  .Mui-selected && {
    color: #fff;
  }
`;

const EndUserTaskFiltersEngine = ({
  counts,
  filtersChangedCallback = () => {},
  passedFilters = {}
}) => {
  const [priorityValue, setPriorityValue] = useState([]);
  const [statusValue, setStatusValue] = useState([]);
  const [dateValue, setDateValue] = useState(null);
  const [dateFilters, setDateFilters] = useState({
    checkedDateOptions: [],
    fromDate: null,
    toDate: null
  });

  useEffect(() => {
    const newPriorityValue = passedFilters.priority || [];
    const newStatusValue = passedFilters.status || [];
    const newDateFilters = passedFilters.dateFilters || {};
    if (JSON.stringify(newPriorityValue) !== JSON.stringify(priorityValue)) {
      setPriorityValue(newPriorityValue);
    }
    if (JSON.stringify(newStatusValue) !== JSON.stringify(statusValue)) {
      setStatusValue(newStatusValue);
    }
    if (JSON.stringify(newDateFilters) !== JSON.stringify(dateFilters)) {
      setDateFilters(newDateFilters);
    }
  }, [passedFilters]);

  const onPriorityChange = v => {
    filtersChangedCallback({
      status: statusValue,
      priority: v,
      dateFilters
    });
    setPriorityValue(v);
  };
  const openMenuOptionParserForPriority = opt => {
    const v = (
      <span>
        {opt.text} <CountSpan>({counts.priority[opt.value] || '0'})</CountSpan>
      </span>
    );
    return v;
  };
  const onStatusChange = v => {
    filtersChangedCallback({
      status: v,
      priority: priorityValue,
      dateFilters
    });
    setStatusValue(v);
  };
  const openMenuOptionParserForStatus = opt => {
    const v = (
      <span>
        {opt.text} <CountSpan>({counts.status[opt.value] || '0'})</CountSpan>
      </span>
    );
    return v;
  };
  const onDateFiltersChange = obj => {
    filtersChangedCallback({
      status: statusValue,
      priority: priorityValue,
      dateFilters: obj
    });
  };
  const viewProps = {
    counts,
    onPriorityChange,
    openMenuOptionParserForPriority,
    priorityOptions,
    priorityValue,
    onStatusChange,
    openMenuOptionParserForStatus,
    statusOptions,
    statusValue,
    onDateFiltersChange,
    dateFilters
  };

  return <EndUserTaskFiltersView {...viewProps} />;
};

export default EndUserTaskFiltersEngine;
